import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import { FaCheck, FaTimes, FaStore, FaChartLine, FaLink, FaUserTie } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

//Components
import businesseservice from "../../../services/business_services"

class AdminBusiness extends Component {
    constructor(props) {
        super(props)
        this.state = {
            businesses: [],
            deactivated: false,
            registered: false,
            selectKey: null,
            order: 'asc',
            loading: true,
            searchQuery: '',
            unlinkedUsers: [],
            loadingUsers: false,
            showLinkModal: false,
            selectedUser: null,
            selectedBusinessForLink: null,
            viewMode: 'businesses', // 'businesses' or 'users'
            linkableBusinesses: [],
        }
    }

    componentDidMount = async () => {
        await this.loadBusinesses()
        const linkableBusinesses = await businesseservice.businesses(false, false)
        linkableBusinesses.sort((a, b) => a.business_name.localeCompare(b.business_name))
        this.setState({ linkableBusinesses })
    }

    loadBusinesses = async () => {
        this.setState({ loading: true })
        const businesses = await businesseservice.businesses(this.state.deactivated, this.state.registered)
        this.setState({ businesses, loading: false })
    }

    loadUnlinkedUsers = async () => {
        this.setState({ loadingUsers: true })
        try {
            const unlinkedUsers = await businesseservice.getUnlinkedBusinessUsers()
            this.setState({ unlinkedUsers, loadingUsers: false })
        } catch (e) {
            NotificationManager.error(e.response?.data?.message || 'Error loading unlinked users')
            this.setState({ loadingUsers: false })
        }
    }

    switchToBusinesses = () => {
        this.setState({ viewMode: 'businesses' })
    }

    switchToUsers = async () => {
        this.setState({ viewMode: 'users' })
        if (this.state.unlinkedUsers.length === 0) {
            await this.loadUnlinkedUsers()
        }
    }

    switchDeactivated = async () => {
        this.setState({ deactivated: !this.state.deactivated }, () => this.loadBusinesses())
    }

    switchRegistered = async () => {
        this.setState({ registered: !this.state.registered }, () => this.loadBusinesses())
    }

    reorder = async (key) => {
        let order = 'asc'
        if (this.state.selectKey === key && this.state.order === 'asc')
            order = 'desc'
        this.setState({ selectKey: key, order })
        let businesses = this.state.businesses
        if (order === 'asc')
            businesses.sort((a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0))
        else
            businesses.sort((a, b) => (a[key] < b[key]) ? 1 : ((b[key] < a[key]) ? -1 : 0))
        this.setState({ businesses })
    }

    activate = async (business_uuid) => {
        try {
            const data = await businesseservice.activateBusiness(business_uuid)
            NotificationManager.success(data.message)
            this.loadBusinesses()
        } catch (e) {
            NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
        }
    }

    deactivate = async (business_uuid) => {
        try {
            const data = await businesseservice.deactivateBusiness(business_uuid)
            NotificationManager.success(data.message)
            this.loadBusinesses()
        } catch (e) {
            NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
        }
    }

    openLinkModal = async (user) => {
        this.setState({
            showLinkModal: true,
            selectedUser: user,
            selectedBusinessForLink: null,
        })
    }

    closeLinkModal = () => {
        this.setState({
            showLinkModal: false,
            selectedUser: null,
            selectedBusinessForLink: null,
        })
    }

    linkUserToBusiness = async () => {
        if (!this.state.selectedBusinessForLink) {
            NotificationManager.error('Please select a business')
            return
        }
        try {
            const data = await businesseservice.linkUserToBusiness(
                this.state.selectedBusinessForLink,
                this.state.selectedUser.user_uuid
            )
            NotificationManager.success(data.message)
            this.closeLinkModal()
            await this.loadUnlinkedUsers()
        } catch (e) {
            NotificationManager.error(e.response?.data?.message || 'Error linking user to business')
        }
    }

    render() {
        return (
            <>
                <AdminLayout
                    title="Business Management"
                    breadcrumbs={[{ label: 'Business' }]}
                >
                    <div className="space-y-6">
                        {/* Action Buttons */}
                        <div className="flex flex-wrap gap-3 items-center">
                            <button
                                onClick={() => window.location.href = '/admin/business/activities'}
                                className="px-4 py-2 bg-gradient-to-r from-purple-500 to-indigo-600 text-white rounded-lg hover:from-purple-600 hover:to-indigo-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                            >
                                <FaChartLine />
                                Manage Activities
                            </button>

                            <div className="flex bg-white border border-gray-300 rounded-lg overflow-hidden shadow-sm">
                                <button
                                    onClick={this.switchToBusinesses}
                                    className={`px-4 py-2 font-medium transition-all flex items-center gap-2 ${this.state.viewMode === 'businesses'
                                            ? 'bg-gradient-to-r from-gray-700 to-gray-800 text-white'
                                            : 'bg-white text-gray-700 hover:bg-gray-50'
                                        }`}
                                >
                                    <FaStore />
                                    Businesses
                                </button>
                                <button
                                    onClick={this.switchToUsers}
                                    className={`px-4 py-2 font-medium transition-all flex items-center gap-2 border-l border-gray-300 ${this.state.viewMode === 'users'
                                            ? 'bg-gradient-to-r from-blue-500 to-cyan-600 text-white'
                                            : 'bg-white text-gray-700 hover:bg-gray-50'
                                        }`}
                                >
                                    <FaUserTie />
                                    Unlinked Users
                                </button>
                            </div>
                        </div>

                        {/* Businesses View */}
                        {this.state.viewMode === 'businesses' && (
                            <>
                                {/* Filters Section */}
                                <div className="bg-gradient-to-br from-gray-50 to-slate-50 rounded-xl p-6 border border-gray-200">
                                    <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                                        <FaStore className="text-gray-600" />
                                        {this.state.deactivated ? "Deactivated" : "Active"} {this.state.registered ? "Registered" : "Referenced"} Businesses
                                    </h3>

                                    <div className="flex flex-wrap gap-3 items-center">
                                        <input
                                            type="text"
                                            placeholder="Search by business name..."
                                            value={this.state.searchQuery}
                                            onChange={(e) => this.setState({ searchQuery: e.target.value })}
                                            className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none text-sm w-64"
                                        />
                                        <button
                                            onClick={this.switchDeactivated}
                                            className={`px-4 py-2 rounded-lg transition-all font-medium shadow-md hover:shadow-lg ${this.state.deactivated
                                                    ? 'bg-gray-500 text-white hover:bg-gray-600'
                                                    : 'bg-green-500 text-white hover:bg-green-600'
                                                }`}
                                        >
                                            {this.state.deactivated ? 'Show Active' : 'Show Deactivated'}
                                        </button>
                                        <button
                                            onClick={this.switchRegistered}
                                            className={`px-4 py-2 rounded-lg transition-all font-medium shadow-md hover:shadow-lg ${this.state.registered
                                                    ? 'bg-blue-500 text-white hover:bg-blue-600'
                                                    : 'bg-orange-500 text-white hover:bg-orange-600'
                                                }`}
                                        >
                                            {this.state.registered ? 'Show Referenced Only' : 'Show Registered Only'}
                                        </button>
                                    </div>
                                </div>

                                {/* Table */}
                                {this.state.loading ? (
                                    <div className="bg-white rounded-xl shadow-md border border-gray-200 p-8 text-center">
                                        <p className="text-gray-600">Loading...</p>
                                    </div>
                                ) : (
                                    <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                                        <div className="overflow-x-auto">
                                            <table className="w-full">
                                                <thead className="bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-gray-200">
                                                    <tr>
                                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase w-12">#</th>
                                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-blue-100 transition-colors" onClick={() => this.reorder("business_name")}>
                                                            ⥃ Business Name
                                                        </th>
                                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-blue-100 transition-colors" onClick={() => this.reorder("website")}>
                                                            ⥃ Website
                                                        </th>
                                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-blue-100 transition-colors w-40" onClick={() => this.reorder("city")}>
                                                            ⥃ City
                                                        </th>
                                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-blue-100 transition-colors w-40" onClick={() => this.reorder("country")}>
                                                            ⥃ Country
                                                        </th>
                                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-blue-100 transition-colors w-40" onClick={() => this.reorder("created_date")}>
                                                            ⥃ Created Date
                                                        </th>
                                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-blue-100 transition-colors w-32" onClick={() => this.reorder("nb_players")}>
                                                            ⥃ Players
                                                        </th>
                                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase w-32">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="divide-y divide-gray-200">
                                                    {this.state.businesses.filter(b => !this.state.searchQuery || b.business_name?.toLowerCase().includes(this.state.searchQuery.toLowerCase())).map((business, index) => (
                                                        <tr key={`business_${business.business_uuid}`} className="hover:bg-gray-50 transition-colors">
                                                            <td className="px-4 py-3">
                                                                <span className="font-semibold text-gray-700">{index + 1}</span>
                                                            </td>
                                                            <td className="px-4 py-3">
                                                                <span className="text-sm text-gray-900">
                                                                    {business.business_name && business.business_name.length > 35
                                                                        ? `${business.business_name.substring(0, 35)}...`
                                                                        : business.business_name}
                                                                </span>
                                                            </td>
                                                            <td className="px-4 py-3">
                                                                <a
                                                                    href={business.website}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                    className="text-blue-600 hover:text-blue-800 text-xs hover:underline"
                                                                >
                                                                    {business.website && business.website.length > 30
                                                                        ? `${business.website.substring(0, 30)}...`
                                                                        : business.website}
                                                                </a>
                                                            </td>
                                                            <td className="px-4 py-3">
                                                                <span className="text-sm text-gray-700">
                                                                    {business.city && business.city.length > 20
                                                                        ? `${business.city.substring(0, 20)}...`
                                                                        : business.city}
                                                                </span>
                                                            </td>
                                                            <td className="px-4 py-3">
                                                                <span className="text-sm text-gray-700">
                                                                    {business.country && business.country.length > 20
                                                                        ? `${business.country.substring(0, 20)}...`
                                                                        : business.country}
                                                                </span>
                                                            </td>
                                                            <td className="px-4 py-3">
                                                                <span className="text-sm text-gray-700">
                                                                    {business.created_date ? new Date(business.created_date).toLocaleDateString() : '-'}
                                                                </span>
                                                            </td>
                                                            <td className="px-4 py-3 text-center">
                                                                <span className="text-sm font-medium text-gray-700">
                                                                    {business.nb_players ?? '-'}
                                                                </span>
                                                            </td>
                                                            <td className="px-4 py-3">
                                                                <div className="flex items-center justify-center gap-2">
                                                                    <button
                                                                        onClick={() => window.location.href = `/admin/business/details/${business.business_uuid}`}
                                                                        className="px-3 py-1 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors text-sm font-medium"
                                                                    >
                                                                        Details
                                                                    </button>
                                                                    {this.state.deactivated ? (
                                                                        <button
                                                                            onClick={() => this.activate(business.business_uuid)}
                                                                            className="p-2 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 transition-colors"
                                                                            title="Activate"
                                                                        >
                                                                            <FaCheck />
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            onClick={() => this.deactivate(business.business_uuid)}
                                                                            className="p-2 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 transition-colors"
                                                                            title="Deactivate"
                                                                        >
                                                                            <FaTimes />
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}

                        {/* Unlinked Business Users View */}
                        {this.state.viewMode === 'users' && (
                            <>
                                {this.state.loadingUsers && (
                                    <div className="bg-white rounded-xl shadow-md border border-gray-200 p-8 text-center">
                                        <p className="text-gray-600">Loading unlinked users...</p>
                                    </div>
                                )}

                                {!this.state.loadingUsers && this.state.unlinkedUsers.length > 0 && (
                                    <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                                        <div className="bg-gradient-to-r from-blue-50 to-cyan-50 px-6 py-4 border-b border-gray-200">
                                            <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                                                <FaUserTie className="text-blue-600" />
                                                Users Without Business ({this.state.unlinkedUsers.length})
                                            </h3>
                                        </div>
                                        <div className="overflow-x-auto">
                                            <table className="w-full">
                                                <thead className="bg-gray-50 border-b border-gray-200">
                                                    <tr>
                                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">#</th>
                                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Email</th>
                                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">First Name</th>
                                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Last Name</th>
                                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="divide-y divide-gray-200">
                                                    {this.state.unlinkedUsers.map((user, index) => (
                                                        <tr key={`user_${user.user_uuid}`} className="hover:bg-gray-50 transition-colors">
                                                            <td className="px-4 py-3">
                                                                <span className="font-semibold text-gray-700">{index + 1}</span>
                                                            </td>
                                                            <td className="px-4 py-3">
                                                                <span className="font-medium text-gray-900">{user.email}</span>
                                                            </td>
                                                            <td className="px-4 py-3">
                                                                <span className="text-sm text-gray-700">{user.firstname || '-'}</span>
                                                            </td>
                                                            <td className="px-4 py-3">
                                                                <span className="text-sm text-gray-700">{user.lastname || '-'}</span>
                                                            </td>
                                                            <td className="px-4 py-3">
                                                                <div className="flex items-center justify-center">
                                                                    <button
                                                                        onClick={() => this.openLinkModal(user)}
                                                                        className="px-3 py-1.5 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors text-sm font-medium flex items-center gap-1"
                                                                    >
                                                                        <FaLink />
                                                                        Link to Business
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}

                                {!this.state.loadingUsers && this.state.unlinkedUsers.length === 0 && this.state.unlinkedUsers !== undefined && Array.isArray(this.state.unlinkedUsers) && (
                                    <div className="bg-white rounded-xl shadow-md border border-gray-200 p-8 text-center">
                                        <FaUserTie className="text-5xl text-gray-400 mx-auto mb-4" />
                                        <p className="text-gray-600 text-lg font-medium">No unlinked business users found</p>
                                        <p className="text-gray-500 text-sm mt-2">All business users are linked to their businesses.</p>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </AdminLayout>

                {/* Link User to Business Modal */}
                {this.state.showLinkModal && this.state.selectedUser && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                        <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full">
                            <div className="bg-gradient-to-r from-blue-500 to-cyan-600 px-6 py-4 flex items-center justify-between rounded-t-xl">
                                <div className="flex items-center gap-3 text-white">
                                    <FaLink className="text-2xl" />
                                    <div>
                                        <h3 className="text-xl font-bold">Link User to Business</h3>
                                        <p className="text-sm text-white/90">
                                            {this.state.selectedUser.email}
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={this.closeLinkModal}
                                    className="text-white hover:bg-white/20 rounded-lg p-2 transition-colors"
                                >
                                    <FaTimes className="text-xl" />
                                </button>
                            </div>

                            <div className="p-6 space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">User Information</label>
                                    <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
                                        <p className="text-sm text-gray-900"><strong>Email:</strong> {this.state.selectedUser.email}</p>
                                        {this.state.selectedUser.firstname && (
                                            <p className="text-sm text-gray-900 mt-1"><strong>First Name:</strong> {this.state.selectedUser.firstname}</p>
                                        )}
                                        {this.state.selectedUser.lastname && (
                                            <p className="text-sm text-gray-900 mt-1"><strong>Last Name:</strong> {this.state.selectedUser.lastname}</p>
                                        )}
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Select Business</label>
                                    <select
                                        value={this.state.selectedBusinessForLink || ''}
                                        onChange={(e) => this.setState({ selectedBusinessForLink: e.target.value })}
                                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                    >
                                        <option value="">Choose a business...</option>
                                        {(this.state.linkableBusinesses || []).map(business => (
                                            <option key={business.business_uuid} value={business.business_uuid}>
                                                {business.business_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="flex justify-end gap-3 pt-4">
                                    <button
                                        onClick={this.closeLinkModal}
                                        className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-all font-medium"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={this.linkUserToBusiness}
                                        disabled={!this.state.selectedBusinessForLink}
                                        className={`px-6 py-2.5 rounded-lg transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2 ${this.state.selectedBusinessForLink
                                                ? 'bg-gradient-to-r from-blue-500 to-cyan-600 text-white hover:from-blue-600 hover:to-cyan-700'
                                                : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                            }`}
                                    >
                                        <FaLink />
                                        Link User
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <NotificationContainer />
            </>
        )
    }
}

export default withTranslation()(AdminBusiness)